export const DIALOGS = {
    LOGIN_DIALOG: "LOGIN_DIALOG",
    ADD_SITE_NOTE_DIALOG: "ADD_NOTE_DIALOG",
    ACCOUNT_DIALOG: "ACCOUNT_DIALOG",
    CHANGE_NAME_DIALOG: "CHANGE_NAME_DIALOG",
    CHANGE_EMAIL_DIALOG: "CHANGE_EMAIL_DIALOG",
    CHANGE_INDUSTRY_DIALOG: "CHANGE_INDUSTRY_DIALOG",
    CHANGE_PASSWORD_DIALOG: "CHANGE_PASSWORD_DIALOG",
};
